import React, { useEffect } from "react";
import {
  ArrowRight,
  CheckCircle2,
  MessageSquareText,
  Route,
  SlidersHorizontal,
} from "lucide-react";
import { Link } from "react-router-dom";
import OfferGrid from "../components/OfferGrid";
import PageMeta from "../components/PageMeta";
import { useLanguage } from "../i18n/LanguageProvider";

const Pricing = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const steps = [
    { icon: MessageSquareText, label: "Décrivez votre besoin" },
    { icon: Route, label: "Nous identifions le bon parcours" },
    { icon: SlidersHorizontal, label: "Vous recevez une proposition adaptée" },
  ];

  return (
    <div className="ws-page ws-pricing" data-no-i18n="true">
      <PageMeta
        title="Offres et tarifs | WonyaSoft"
        description="Découvrez les offres WonyaSoft pour l’intégration de paiements, le paiement en masse, l’encaissement mobile et le développement de solutions monétiques."
      />

      <section className="ws-page-hero">
        <div className="ws-shell ws-page-hero__content">
          <span className="ws-eyebrow">{t("Offres et tarification")}</span>
          <h1>{t("Des offres lisibles, adaptées à votre usage")}</h1>
          <p>
            {t(
              "Les frais d’intégration de l’API WonyaPay sont de 50 USD, avec une commission de 3 % par transaction. L’accès à l’application mobile WonyaPay est gratuit.",
            )}
          </p>
          <Link className="ws-button ws-button--primary" to="/contact">
            {t("Parler à notre équipe")}{" "}
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>
      </section>

      <section className="ws-section" aria-labelledby="ws-pricing-offers-title">
        <div className="ws-shell">
          <div className="ws-section-heading">
            <span className="ws-kicker">{t("Ce qui est inclus")}</span>
            <h2 id="ws-pricing-offers-title">
              {t("Nos principales solutions")}
            </h2>
            <p>
              {t(
                "Trois offres complémentaires pour intégrer, payer en masse ou encaisser sur mobile.",
              )}
            </p>
          </div>
          <OfferGrid showPricing />
        </div>
      </section>

      <section className="ws-section ws-section--soft">
        <div className="ws-shell ws-pricing-process">
          <div className="ws-pricing-process__intro">
            <CheckCircle2 size={36} aria-hidden="true" />
            <h2>{t("Une tarification transparente, sans hypothèse")}</h2>
            <p>
              {t(
                "Chaque proposition est établie à partir de votre flux réel, de vos volumes, des opérateurs concernés et du niveau d’accompagnement attendu.",
              )}
            </p>
          </div>
          <ol className="ws-pricing-process__steps">
            {steps.map(({ icon: Icon, label }, index) => (
              <li key={label}>
                <span className="ws-pricing-process__number">0{index + 1}</span>
                <Icon size={23} aria-hidden="true" />
                <strong>{t(label)}</strong>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="ws-section">
        <div className="ws-shell ws-final-cta">
          <div>
            <span className="ws-kicker">WonyaSoft</span>
            <h2>{t("Construisons votre prochain parcours de paiement")}</h2>
            <p>
              {t(
                "Notre équipe vous accompagne du cadrage jusqu’à l’intégration et la mise en production.",
              )}
            </p>
          </div>
          <Link className="ws-button ws-button--primary" to="/contact">
            {t("Nous contacter")}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Pricing;
